'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var applicationRole = {
  abstract: false,
  accessibleNameRequired: true,
  baseConcepts: [{
    concept: {
      name: 'Device Independence Delivery Unit'
    }
  }],
  childrenPresentational: false,
  nameFrom: ['author'],
  props: {
    'aria-activedescendant': null
  },
  relatedConcepts: [],
  requireContextRole: [],
  requiredOwnedElements: [],
  requiredProps: {},
  superClass: [['roletype', 'structure']]
};

exports.default = applicationRole;